const { isEmptyObject } = require("jquery");

window.$ = window.jQuery = require("jquery");

$(document).ready(function () {
    $('.filter-item label, .filter-item input:checkbox').on('click', function () {
        if ($(this).siblings('input:checkbox').prop("checked") == true) {

            $(this).siblings('input:checkbox').prop("checked", false);

        } else {

            $(this).siblings('input:checkbox').prop("checked", true);

        }
        Array_of_filter = []
        $('.filter-item input:checkbox:checked').each(function () {
            $array_filtre = {};
            $array_filtre['attribut'] = $(this).data('filte_attr');
            if ($(this).data('filte_attr_val') == 'pvc') {
                $array_filtre['attribute_value'] = 'PVC';
            } else {
                $array_filtre['attribute_value'] = $(this).data('filte_attr_val');
            }
            Array_of_filter.push($array_filtre);
        });

        if (Array_of_filter.length == 0) {
            window.location.reload()
        };

        filter_cat_page(Array_of_filter)
    })

    // clear filters category page
    $('.archive .container .filter .title p:nth-child(2)').on('click', function (e) {
        $('.archive .container .filter .title.term_id .clear_filters').on('click');
        window.location.reload()
    });

    function filter_cat_page(Array_of_filter) {
        object_of_filter = JSON.stringify(Object.assign({}, Array_of_filter));
        term_id = $('.term_id').data('term');
        let formData = new FormData();

        console.log('start filter')
        const productsContainer = $('.content-area .products');
        productsContainer.addClass('loading')

        formData.append("term", term_id);
        formData.append("object_of_filter", object_of_filter);
        $.ajax({
            url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'interplast_api_filter_category_page'),
            type: "post",
            data: formData,
            contentType: false,
            processData: false,
            dataType: "html",
            success: function (d) {
                let json = JSON.parse(d);
                let pageCount = Math.ceil(json.count / 10);
                $('.category-wrap .products').replaceWith(json.contentHtml);
                $('.category-wrap .woocommerce-result-count').replaceWith(' <div class="woocommerce-result-count"><p><span class="nb">' + json.count + '</span> résultats</p></div >')

                if (pageCount < 2) {
                    $('.woocommerce-pagination').css('display', 'none')
                } else {
                    $('.woocommerce-pagination').css('display', 'flex')
                }
                productsContainer.removeClass('loading')
            },
        });
    };
    $('.filter .content .name').each(function (index) {
        if ($(this).next('.filter-items').children('.filter-item').length == 0) {
            $(this).css('display', 'none');
        }
    });

    if ($('#mm_filters').hasClass('mm_no_filters')) {
        $('.filter.mm_filter_box').css('opacity', '0');
        $('.filter-wrap').replaceWith('');
        $('.category-wrap').addClass('has_no_filter')
        $('ul.products').addClass('no_filter');
    } else {
        $('.filter.mm_filter_box').css('opacity', '1');
    }

});